import { render, staticRenderFns } from "./suggestDetail.vue?vue&type=template&id=3530fd5d&scoped=true&"
import script from "./suggestDetail.vue?vue&type=script&lang=js&"
export * from "./suggestDetail.vue?vue&type=script&lang=js&"
import style0 from "./suggestDetail.vue?vue&type=style&index=0&id=3530fd5d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3530fd5d",
  null
  
)

export default component.exports